import { useEffect } from "react";

/**
 * Redirige a /poemario/index.html cuando el servidor estático no resuelve
 * /poemario/ automáticamente al index.html del subdirectorio.
 * Usamos window.location.replace para forzar carga del HTML estático real
 * (no React Router) y arrancar la PWA con su propio service worker.
 */
export default function PoemarioRedirect() {
  useEffect(() => {
    window.location.replace("/poemario/index.html");
  }, []);
  return null;
}
